import { Box, Typography } from "@mui/material";
import { AddEndorsementButton } from "./AddEndorsementButton";

interface Props {
  canManageEndorsements: boolean;
  handleCreateNewEndorsement: () => void;
  isEligibilityLoading: boolean;
}

export const EmptyEndorsementsList = ({
  canManageEndorsements,
  handleCreateNewEndorsement,
  isEligibilityLoading,
}: Props) => {
  return (
    <Box
      sx={{
        py: 8,
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        gap: 1.5,
      }}>
      <Typography variant="body2" color="text.secondary">
        Nothing here yet
      </Typography>
      <AddEndorsementButton
        canManageEndorsements={canManageEndorsements}
        handleCreateNewEndorsement={handleCreateNewEndorsement}
        isEligibilityLoading={isEligibilityLoading}
      />
    </Box>
  );
};
